import axios from "axios";
import { API_URL } from "../_config/config.const";
import { handleResponse } from "../_helpers/handleResponse.helper";
import { getHeader, getUploadHeader } from "../_helpers/header.helper";
import { getBody } from "../_helpers/body.helper";

const API_NAME = "mediaInformation";

export const mediaInformationService = {
    get,
    update,
};

function get(id: string) {
    const requestOptions = { method: 'GET', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/Get/?id=${id}`, requestOptions).then(handleResponse);
}


function update(model?: any) {
    const requestOptions = { method: 'PUT', headers: getHeader(), body: getBody(model) };
    return fetch(`${API_URL}/${API_NAME}`, requestOptions).then(handleResponse);
}
